import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import WidgetApp from "./components/WidgetApp";
import { LoaderProvider } from './providers/LoaderProvider';
import { WidgetProvider } from './providers/WidgetProvider';


function ErrorFallback({ error, resetErrorBoundary }) {
  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre>{error.message}</pre>
      <code>{JSON.stringify(error)}</code>
    </div>
  );
}
const App = () => {
  
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
    <LoaderProvider>
      <WidgetProvider>
        <WidgetApp />
      </WidgetProvider>
    </LoaderProvider>
  </ErrorBoundary>
  );
}

export default App;
